import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function SearchBox({ showBarcode, searchResult, placeholder, width, value }) {
  const { t, i18n } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");

  // Default width class if not provided
  const widthClass = width ? `w-[${width}]` : "w-80";

  return (
    <div className="relative flex items-center">
      <div
        className={`absolute inset-y-0 ${
          i18n.language === "ar" ? "right-0 pr-4" : "left-0 p-4"
        } flex items-center pointer-events-none`}
      >
        <svg
          className="w-4 h-4 text-gray-500"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 20 20"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
          />
        </svg>
      </div>
      <input
        type="search"
        id="default-search"
        className={`block h-10 ${widthClass} text-sm text-gray-950 font-normal border pe-2 ${
          i18n.language === "ar" ? "ps-10 text-right" : "ps-10 text-left"
        } rounded-md border-[#CCCCCC]`}
        style={{ outline: "none" }}
        placeholder={t(placeholder)}
        value={value != undefined ? value : searchTerm}
        onChange={(event) => {
          setSearchTerm(event.target.value);
          searchResult(event.target.value);
          // if(shortCode){
          //   searchResult(event.target.value);
          // }else if (
          //   event.target.value.length >= 2 ||
          //   event.target.value.length === 0
          // ) {
          //   searchResult(event.target.value);
          // }
        }}
        required
      />
    </div>
  );
}

export default SearchBox;
